import React, { useEffect, useRef, useState } from "react";

/**
 * "More Filters" pill button + popover wrapper. Pass children to render
 * the per-list filter form inside. Closes on outside click + Escape.
 */
const FilterPopover = ({ children, count = 0, label = "More Filters" }) => {
  const [open, setOpen] = useState(false);
  const wrapperRef = useRef(null);

  useEffect(() => {
    if (!open) return undefined;
    const handlePointer = (e) => {
      if (wrapperRef.current && !wrapperRef.current.contains(e.target)) {
        setOpen(false);
      }
    };
    const handleKey = (e) => {
      if (e.key === "Escape") setOpen(false);
    };
    document.addEventListener("mousedown", handlePointer);
    document.addEventListener("keydown", handleKey);
    return () => {
      document.removeEventListener("mousedown", handlePointer);
      document.removeEventListener("keydown", handleKey);
    };
  }, [open]);

  return (
    <div
      className={`filter-popover ${open ? "open" : ""}`}
      ref={wrapperRef}
    >
      <button
        type="button"
        className="filter-popover-trigger"
        onClick={() => setOpen((o) => !o)}
      >
        <i className="fas fa-sliders fa-rotate-90 me-2" />
        <span>{label}</span>
        {count > 0 && <span className="filter-count-badge">{count}</span>}
      </button>

      {open && (
        <div
          className="filter-popover-panel"
          onClick={(e) => e.stopPropagation()}
        >
          {typeof children === "function" ? children(() => setOpen(false)) : children}
        </div>
      )}
    </div>
  );
};

export default FilterPopover;
